export const MS_PER_DAY = 86400000;

export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]; // Python weekday() order

export const SITE_STATUSES = [
  { v: "active", label: "Active", tone: "green" },
  { v: "paused", label: "Paused", tone: "amber" },
  { v: "ended", label: "Ended", tone: "default" },
];

export const SHIFT_STATUSES = [
  { v: "scheduled", label: "Scheduled", tone: "blue" },
  { v: "in_progress", label: "In Progress", tone: "amber" },
  { v: "completed", label: "Completed", tone: "green" },
];

export const emptyShift = {
  guard_ids: [],
  site_id: "",
  start_time: "",
  end_time: "",
  notes: "",
  series_label: "",
  min_guards: 1,
  repeats: false,
  recurrence_days: [],
  recurrence_end_date: "",
};

export function startOfWeek(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  x.setDate(x.getDate() - x.getDay());
  return x;
}

export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function isoDate(d) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function jsDayToPy(d) {
  return (d.getDay() + 6) % 7; // Mon=0..Sun=6
}

export function toneForStatus(s) {
  return ({ scheduled: "blue", in_progress: "amber", completed: "green" }[s] || "default");
}
